import { PortalEnvironment } from './environments';
import { ADMIN_NAV } from './admin-nav';
import './admin.generated.css';

/**
 * The operations console, as configuration.
 *
 * Steel rather than blue, and the same `.shell / .top / .side` chrome the
 * family uses — which is the whole point of having separated chrome from
 * environment: this file is the entire difference.
 *
 * The rail's labels are bare text, so `navLabelClass` is left unset; wrapping
 * them in an unclassed span picks up rules meant for the icon and the badge.
 */
export const ADMIN_ENVIRONMENT: PortalEnvironment = {
  scope: 'env-admin',
  chrome: 'console',
  consoleHeader: 'ops',
  badge: 'Operaciones',
  home: '/admin/dashboard/ops',
  nav: ADMIN_NAV,
  accountLinks: [
    { label: 'Perfil', to: '/profile' },
    { label: 'Ajustes', to: '/settings' },
    { label: 'Centro de ayuda', to: '/help' },
  ],
};
